import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './store';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css'
import { GoogleOAuthProvider } from '@react-oauth/google';

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement!);

const client_id = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

root.render(
  <Provider store={store}>
     <GoogleOAuthProvider clientId={client_id}>
    <Router>
    <App />
    </Router>
    </GoogleOAuthProvider>
  </Provider>
);
